import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const CHANNELS = [
  { name: "Instagram", url: "https://www.instagram.com/tronamusic/" },
  { name: "Youtube", url: "https://www.youtube.com/@TronaMusicOfficial" },
  { name: "Soundcloud", url: "https://soundcloud.com/tronamusic" },
  { name: "TikTok", url: "https://www.tiktok.com/@tronamusicofficial" },
  { name: "Telegram", url: "https://t.me/tronamusic" },
];

export default function Social() {
  return (
    <main
      className="px-6 md:px-12 w-full max-w-6xl mx-auto pt-10 md:pt-16 flex-1"
      data-testid="social-page"
    >
      <Seo
        title="Social — TRONA"
        siteName="TRONA"
        description="TRONA channels: Instagram, YouTube, SoundCloud, TikTok, Spotify, Telegram."
      />
      <Reveal>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-none tracking-tight text-[#1A1512]">
          Social
        </h1>
      </Reveal>
        <Reveal delay={0.05}>
          <ul className="mt-12 border-t border-[#1A1512]" data-testid="social-list">
            {CHANNELS.map((c) => (
              <li key={c.name} className="border-b border-[#1A1512]/25">
                <a
                  href={c.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-link-${c.name.toLowerCase()}`}
                  className="block py-5 font-mono font-bold text-[13px] sm:text-sm tracking-[0.25em] uppercase text-[#1A1512] hover:text-[#504439] transition-colors duration-150"
                >
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </Reveal>
    </main>
  );
}
